import { render, staticRenderFns } from "./sale-contract-type.vue?vue&type=template&id=b72bd712"
import script from "./sale-contract-type.vue?vue&type=script&lang=js"
export * from "./sale-contract-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports